var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M10.054 2.79c.019.02.07.08.152.23.137.251.292.62.524 1.173l2.026 4.837.32.761.646-.514 2.701-2.149c.417-.331.691-.548.903-.682a1 1 0 0 1 .21-.112.2.2 0 0 1 .1.05c.009.021.03.086.045.232.026.25.027.599.027 1.131v5.421c0 1.39-.013 1.897-.3 2.454a3.4 3.4 0 0 1-.688.853c-.49.403-.865.494-1.923.724-1.297.28-2.928.51-4.797.51-1.87 0-3.5-.23-4.797-.51-1.058-.23-1.434-.32-1.924-.724a3.4 3.4 0 0 1-.688-.853c-.286-.557-.3-1.064-.3-2.454v-5.42c0-.533.002-.883.028-1.132a1 1 0 0 1 .044-.233.2.2 0 0 1 .1-.049 1 1 0 0 1 .211.112c.211.134.485.35.902.682l2.702 2.149.645.514.32-.761L9.27 4.193c.232-.553.387-.922.523-1.172.082-.15.133-.21.152-.23a.2.2 0 0 1 .11 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.25,
  d: "M10 14.167v-3.334"
})));
export default SvgCrown;